import { render } from "./LogoCliente.vue?vue&type=template&id=222bcbe8&scoped=true"
import script from "./LogoCliente.vue?vue&type=script&lang=js"
export * from "./LogoCliente.vue?vue&type=script&lang=js"

import "./LogoCliente.vue?vue&type=style&index=0&id=222bcbe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222bcbe8"]])

export default __exports__